<div class="exception-body">
    <div class="exception-panel">
        <img [src]="assestBaseUrl + 'layout/images/icon-404.png'"  alt="404" />

        <h1>Page Not Found</h1>
        <p>The page you requested cannot be found.</p>
        <button type="button" pButton label="GO TO DASHBOARD" [routerLink]="['/']" class="p-button-secondary"></button>
    </div>
</div>
